import { Link } from 'react-router-dom';
import { Reveal } from '@/components/utils/RevealOnScroll';

/**
 * "Built on Radium" callout — sits at the top of /personalization.
 * PRD-07 §7.6.1: ratifies the substrate-application story, gives the
 * technical buyer a credibility signal, bridges back to the OSS audience.
 */
export function BuiltOnRadium() {
  return (
    <section
      style={{
        paddingTop: 16,
        paddingBottom: 64,
      }}
    >
      <div className="container">
        <Reveal>
          <div
            className="surface bor-grid"
            style={{
              padding: '32px 36px',
              borderRadius: 8,
              borderLeft: '3px solid var(--accent)',
              display: 'grid',
              gridTemplateColumns: '1fr auto',
              gap: 32,
              alignItems: 'center',
            }}
          >
            <div>
              <div
                className="text-eyebrow"
                style={{ marginBottom: 12, color: 'var(--accent)' }}
              >
                Built on the Radium platform
              </div>
              <p
                style={{
                  color: 'var(--ink-secondary)',
                  fontSize: 16,
                  lineHeight: 1.65,
                  maxWidth: 760,
                }}
              >
                Radium for Personalization is one application of the
                open-source Radium orchestration platform. The runtime, the
                policy engine, the metacognitive oversight, and the learning
                system you'd find in{' '}
                <code
                  style={{
                    fontFamily: 'var(--font-mono)',
                    background: 'rgba(255,255,255,0.06)',
                    padding: '1px 6px',
                    borderRadius: 3,
                    fontSize: 14,
                  }}
                >
                  rad
                </code>{' '}
                are the same systems running underneath every personalization
                decision the product makes. The platform is observable. The
                application is governed. Both are open about how they work.
              </p>
            </div>
            <Link
              to="/orchestration"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                color: 'var(--accent)',
                fontSize: 14,
                fontWeight: 500,
                whiteSpace: 'nowrap',
                textDecoration: 'none',
              }}
            >
              Explore the platform <span aria-hidden="true">→</span>
            </Link>
          </div>
        </Reveal>
      </div>
      <style>{`
        @media (max-width: 760px) {
          .bor-grid {
            grid-template-columns: 1fr !important;
            gap: 16px !important;
          }
        }
      `}</style>
    </section>
  );
}
